module.exports = __webpack_public_path__ + "static/media/3.6.51e07094.png";